import { AddRemoveFromGroup } from "@/components/dashboard/flows/actions/AddRemoveFromGroup";
import { CompletesAForm } from "@/components/dashboard/flows/triggers/CompletesAForm";
import { IssueTicket } from "@/components/dashboard/flows/actions/IssueTicket";
import { Action } from "@/models/flows";
import {
  BookCheckIcon,
  Box,
  CircleCheck,
  ClockIcon,
  DollarSign,
  PackageMinus,
  PackagePlus,
  Send,
  Split,
  SplitIcon,
  Ticket,
  Tickets,
  User,
} from "lucide-react";
import { StartWithAnIndividual } from "@/components/dashboard/flows/triggers/StartWithAnIndividual";

// Actions that start the flow
export const TRIGGERS: Array<Action> = [
  {
    label: "When individual completes form",
    type: "completesForm",
    icon: Send,
    colour: "yellow",
    component: <CompletesAForm />,
    description:
      "Trigger this flow when an individual completes a particular form",
  },
  {
    label: "Start with individual",
    type: "startWithIndividual",
    icon: User,
    colour: "yellow",
    component: <StartWithAnIndividual />,
    description:
      "Start this flow manually for a given individual in particular group",
  },
];

// Regular actions. Grouped by Category
export const ACTIONS: Record<string, Array<Action>> = {
  Accreditation: [
    {
      label: "Create individual",
      type: "create_individual",
      icon: PackagePlus,
      colour: "blue",
      component: <AddRemoveFromGroup type="Add" />,
      description: "Create an individual in a particular group",
    },
    {
      label: "Create group",
      type: "createGroup",
      icon: Box,
      colour: "blue",
      component: <div>create group</div>,
      description: "Create a parent group or a sub-group",
    },
    {
      label: "Allocate tickets",
      type: "allocateTickets",
      icon: Tickets,
      colour: "blue",
      component: <div>allocate tickets</div>,
      description: "Allocate tickets to a group",
    },
    // {
    //   label: "Remove from group",
    //   type: "removeFromGroup",
    //   icon: PackageMinus,
    //   colour: "blue",
    //   component: <AddRemoveFromGroup type="Remove" />,
    // },
    // {
    //   label: "Issue ticket",
    //   type: "issueTicket",
    //   icon: Ticket,
    //   colour: "blue",
    //   component: <IssueTicket />,
    // },
  ],
  Payment: [
    {
      label: "Request payment",
      type: "request_payment",
      icon: DollarSign,
      colour: "green",
      component: <div>Request payment</div>,
      description: "Request payment from an individual. Useful for bonds etc.",
    },
  ],
  General: [
    {
      label: "Send email",
      type: "send_email",
      icon: Send,
      colour: "purple",
      component: <div>send email</div>,
      description:
        "Send an email to an individual or all individuals in a group",
    },
    // manaul approve/reject
    {
      label: "Require approval",
      type: "approval",
      icon: CircleCheck,
      colour: "purple",
      component: <div>require approval</div>,
      description:
        "Pauses the execution of the flow and requires manual approval to continue",
    },
    {
      label: "Send form and wait",
      type: "send_form_and_wait",
      icon: BookCheckIcon,
      colour: "purple",
      component: <div>send form and wait</div>,
      description:
        "Send a form to an individual and wait for them to complete it before resuming the flow",
    },
    {
      label: "Condition",
      type: "condition",
      icon: SplitIcon,
      colour: "purple",
      component: <div>send form and wait</div>,
      description: "Wait a specified amount of time before resuming the flow",
    },
    // todo: coming soon tm
    // something to power an automatic decision
    // {
    //   label: "Decision",
    //   type: "decision",
    //   icon: Split,
    //   colour: "purple",
    //   component: <div>decision</div>,
    // },
  ],
  Time: [
    {
      label: "Delay",
      type: "delay",
      icon: ClockIcon,
      colour: "orange",
      component: <div>send form and wait</div>,
      description: "Wait a specified amount of time before resuming the flow",
    },
    {
      label: "Wait for event",
      type: "wait_for_event",
      icon: ClockIcon,
      colour: "orange",
      component: <div>send form and wait</div>,
      description:
        "Wait for a specific event to occur before resuming the flow",
    },
  ],
};

export type StepType =
  | "approval"
  | "create_individual"
  | "request_payment"
  | "send_email"
  | "send_form_and_wait";

export type TriggerType = "form_submitted" | "manual";

export type TriggerTargetType = "individual" | "group";

export type StepEdgeCondition = "approved" | "declined";

export type RunStatus =
  | "pending"
  | "running"
  | "completed"
  | "failed"
  | "skipped"
  | "waiting";
